// ESWM-298: standalone entry so scroll-reveal can be excluded from WP Rocket Delay JS.
import scrollRevealInit from "./modules/scroll-reveal.js";

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", scrollRevealInit, { once: true });
} else {
	scrollRevealInit();
}
